// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__2aDLg","title":"styles_title__usmnl","description":"styles_description__sJENh"};